<template>
  <div>
    <el-alert
      title="按产品加批次追溯已审核库存单据，也可按托盘号查。树里包含工单领料和入库、跨仓移库，勾选后包含已过账重包装。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-select v-model="form.productId" filterable clearable placeholder="产品" style="width:240px">
        <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + p.productName" :value="p.productId" />
      </el-select>
      <el-input v-model="form.batchNo" clearable placeholder="批次号" style="width:160px" @keyup.enter.native="doTrace" />
      <el-input v-model="form.palletCode" clearable placeholder="托盘号" style="width:140px" />
      <el-select v-model="form.direction" style="width:130px">
        <el-option label="全部" value="ALL" />
        <el-option label="反向(来源)" value="BACKWARD" />
        <el-option label="正向(去向)" value="FORWARD" />
      </el-select>
      <el-input-number v-model="form.maxDepth" :min="1" :max="8" />
      <el-checkbox v-model="form.includeTransfers">跨仓移库</el-checkbox>
      <el-checkbox v-model="form.includeRepacking">重包装</el-checkbox>
      <el-button type="primary" :loading="loading" @click="doTrace">追溯</el-button>
      <el-button @click="clearProduct">清空产品</el-button>
    </div>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="谱系树" name="tree">
        <el-tree
          v-if="treeData.length"
          :data="treeData"
          :props="treeProps"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
        >
          <span slot-scope="{ data }" class="gene-tree-node">
            <span>{{ data.label }}</span>
            <el-tag v-if="data.totalQty != null" size="mini" style="margin-left:8px">数量 {{ data.totalQty }}</el-tag>
            <el-tag v-if="data.documents && data.documents.length" size="mini" type="info" style="margin-left:4px">单据 {{ data.documents.length }}</el-tag>
            <el-button v-if="data.documents && data.documents.length" type="text" size="mini" style="margin-left:8px" @click.stop="showNodeDocs(data)">单据</el-button>
          </span>
        </el-tree>
        <div v-else style="color:#909399;padding:12px 0">暂无树数据，请先追溯</div>
      </el-tab-pane>
      <el-tab-pane label="扁平单据" name="list">
        <el-table :data="dataList" border v-loading="loading">
          <el-table-column prop="documentDate" label="单据日期" width="120" />
          <el-table-column prop="documentCode" label="单据号" width="160" />
          <el-table-column prop="documentTypeName" label="类型" width="110" />
          <el-table-column label="方向" width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag size="small" :type="row.direction === 'FORWARD' ? 'warning' : (row.direction === 'BACKWARD' ? 'success' : 'info')">
                {{ row.direction === 'FORWARD' ? '正向' : (row.direction === 'BACKWARD' ? '反向' : '其他') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="productNumber" label="产品编码" width="120" />
          <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip />
          <el-table-column prop="batchNo" label="批次" width="120" />
          <el-table-column prop="palletCode" label="托盘" width="110" />
          <el-table-column prop="quantity" label="数量" width="90" align="right" />
          <el-table-column prop="wareHouseName" label="仓库" width="100" />
          <el-table-column label="移出→移入" min-width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-if="row.documentType === '03'">{{ row.fromWareHouseName || '-' }} → {{ row.toWareHouseName || '-' }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="wareAreaName" label="库位" width="90" />
          <el-table-column prop="orderCode" label="关联工单" width="130" />
          <el-table-column prop="sourceType" label="来源" width="90" />
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="节点单据" :visible.sync="docsVisible" width="980px">
      <el-table :data="nodeDocs" border size="small">
        <el-table-column prop="documentCode" label="单据号" width="150" />
        <el-table-column prop="documentTypeName" label="类型" width="100" />
        <el-table-column prop="orderCode" label="工单" width="120" />
        <el-table-column prop="batchNo" label="批次" width="110" />
        <el-table-column prop="palletCode" label="托盘" width="100" />
        <el-table-column prop="quantity" label="数量" width="80" align="right" />
        <el-table-column prop="wareHouseName" label="仓库" width="100" />
        <el-table-column label="移出→移入" min-width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.documentType === '03'">{{ row.fromWareHouseName || '-' }} → {{ row.toWareHouseName || '-' }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="documentDate" label="日期" width="110" />
      </el-table>
      <span slot="footer"><el-button @click="docsVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { traceGenealogy, traceGenealogyTree } from '../../api/genealogy'
import { selectProduct } from '../../api/product'

export default {
  data() {
    return {
      form: {
        productId: '', batchNo: '', palletCode: '', direction: 'ALL',
        maxDepth: 5, includeTransfers: true, includeRepacking: true
      },
      products: [], dataList: [], treeData: [], loading: false, activeTab: 'tree',
      treeProps: { children: 'children', label: 'label' },
      docsVisible: false, nodeDocs: []
    }
  },
  created() {
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
    this.applyQuery(this.$route.query || {})
  },
  watch: {
    '$route.query': {
      handler(q) { this.applyQuery(q || {}) },
      deep: true
    }
  },
  methods: {
    clearProduct() { this.form.productId = '' },
    applyQuery(q) {
      if (!q.batchNo && !q.palletCode) return
      this.form.batchNo = q.batchNo || ''
      this.form.productId = q.productId || ''
      this.form.palletCode = q.palletCode || ''
      this.doTrace()
    },
    toTreeNodes(node, seq) {
      if (!node) return null
      const id = (node.productId || '') + '|' + (node.batchNo || '') + '|' + (node.wareHouseId || '') + '|' + (node.palletId || '') + '|' + (seq.n++)
      const item = {
        id,
        label: node.label || ((node.productNumber || '') + ' [' + (node.batchNo || '') + ']'),
        totalQty: node.totalQty,
        documents: node.documents || [],
        children: []
      }
      if (node.children && node.children.length) {
        item.children = node.children.map(c => this.toTreeNodes(c, seq)).filter(Boolean)
      }
      return item
    },
    showNodeDocs(data) {
      this.nodeDocs = data.documents || []
      this.docsVisible = true
    },
    doTrace() {
      if (!this.form.batchNo && !this.form.palletCode) {
        this.$message.warning('请输入批次号或托盘号')
        return
      }
      this.loading = true
      const payload = {
        productId: this.form.productId || '',
        batchNo: this.form.batchNo || '',
        palletCode: this.form.palletCode || '',
        direction: this.form.direction || 'ALL',
        maxDepth: this.form.maxDepth || 5,
        includeTransfers: this.form.includeTransfers !== false,
        includeRepacking: this.form.includeRepacking !== false
      }
      Promise.all([traceGenealogy(payload), traceGenealogyTree(payload)]).then(([flatRes, treeRes]) => {
        this.dataList = flatRes.data || []
        const root = treeRes.data
        this.treeData = root ? [this.toTreeNodes(root, { n: 0 })].filter(Boolean) : []
        if (!this.treeData.length && !this.dataList.length) {
          this.$message.info('未找到匹配的已审核库存单据')
        }
      }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.gene-tree-node { flex: 1; display: flex; align-items: center; font-size: 13px; }
</style>
